import React from 'react'
import Marquee from 'react-fast-marquee'
import { Link } from 'react-router-dom'
import BlogCard from '../components/BlogCard'
import Container from '../components/Container'
import Meta from '../components/Meta'
import ProductCard from '../components/ProductCard'
import SpecialProduct from '../components/SpecialProduct'
import { services } from '../utils/data'

const Home = () => {
  return (
    <>
      <Meta title='Home' />
      <Container class1='home-wrapper-1 py-3'> 
       <div className="row">
            <div className="col-6">
              <div className="main-banner position-relative">
                <img src="images/main-banner-1.jpg" alt="main banner" className='img-fluid rounded-3' />
                <div className="main-banner-content position-absolute">
                  <h4>SUPERECHANEGED FOR PROS.</h4>
                  <h5>iPad S13+ Pro.</h5>
                  <p>From $999.00 or $41/mo</p>
                  <Link className='button'>BUY NOW</Link>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex flex-wrap gap-10 justify-content-between align-items-center">
                <div className="small-banner position-relative">
                  <img src="images/catbanner-01.jpg" alt="main banner" className='img-fluid rounded-3' />
                  <div className="small-banner-content position-absolute">
                    <h4>Best Sale.</h4>
                    <h5>iPad S13+ Pro.</h5>
                    <p>From $999.00 <br /> or $41/mo</p>
                  </div>
                </div>
                <div className="small-banner position-relative">
                  <img src="images/catbanner-02.jpg" alt="main banner" className='img-fluid rounded-3' />
                  <div className="small-banner-content position-absolute">
                    <h4>NEW ARIVAL.</h4>
                    <h5>But IPad Air</h5>
                    <p>From $999.00 <br /> or $41/mo</p>
                  </div>
                </div>
                <div className="small-banner position-relative">
                  <img src="images/catbanner-03.jpg" alt="main banner" className='img-fluid rounded-3' />
                  <div className="small-banner-content position-absolute">
                    <h4>NEW ARIVAL.</h4>
                    <h5>But IPad Air</h5>
                    <p>From $999.00 <br /> or $41/mo</p>
                  </div>
                </div>
                <div className="small-banner position-relative">
                  <img src="images/catbanner-04.jpg" alt="main banner" className='img-fluid rounded-3' />
                  <div className="small-banner-content position-absolute">
                    <h4>NEW ARIVAL.</h4>
                    <h5>But IPad Air</h5>
                    <p>From $999.00 <br /> or $41/mo</p>
                  </div>
                </div>
              </div>
            </div>
       </div>
      </Container>
      <Container class1='home-wrapper-2 py-5 services'>
         <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between">
                
                {services.map((service,index) =>(
                  <div className="d-flex align-items-center gap-15" key={index}>
                    <img src={service.image} alt="services" />
                    <div>
                      <h6>{service.title}</h6>
                      <p className="mb-0">{service.tagline}</p>
                    </div>
                  </div>
                ))}
                       
              </div>
            </div>
          </div>
      </Container>
      <Container class1='home-wrapper-3 py-5'>
         <div className="row">
            <div className="col-12">
              <div className="categories d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Cameras</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/camera.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Smart TV</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/tv.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Smart Watches</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/tv.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Music & Gaming</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/Headphone.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Cameras</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/camera.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Smart TV</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/tv.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Smart Watches</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/tv.jpg" alt="camera" />
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <h6>Music & Gaming</h6>
                    <p>10 Items</p>
                  </div>
                  <img src="images/Headphone.jpg" alt="camera" />
                </div>
              </div>
            </div>
          </div>        
      </Container>
      <Container class1='popular-wrapper py-5 home-wrapper-2'>
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">
              Our Popular Products
            </h3>
          </div>
          <ProductCard />
          <ProductCard />
          <ProductCard />
          <ProductCard />
        </div>
      </Container>
      <Container class1='famous-wrapper py-5 home-wrapper-2'>
         <div className="row">
            <div className="col-3">
              <div className="famous-card position-relative">
                <img src="images/tab1.jpg" className="img-fluid" alt="famous" />
                <div className="famous-content position-absolute">
                  <h5>loream</h5>
                  <h6>
                    Lorem, ipsum dolor.
                  </h6>
                  <p>Lorem ipsum dolor sit amet.</p>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="famous-card position-relative">
                <img src="images/tab.jpg" className="img-fluid" alt="famous" />
                <div className="famous-content position-absolute">
                  <h5 className="text-dark">loream</h5>
                  <h6 className="text-dark">
                    Lorem, ipsum dolor.
                  </h6>
                  <p className="text-dark">Lorem ipsum dolor sit amet.</p>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="famous-card position-relative">
                <img src="images/tab2.jpg" className="img-fluid" alt="famous" />
                <div className="famous-content position-absolute">
                  <h5 className="text-dark">loream</h5>
                  <h6 className="text-dark">
                    Lorem, ipsum dolor.
                  </h6>
                  <p className="text-dark">Lorem ipsum dolor sit amet.</p>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="famous-card position-relative">
                <img src="images/tab3.jpg" className="img-fluid" alt="famous" />
                <div className="famous-content position-absolute">
                  <h5 className="text-dark">loream</h5>
                  <h6 className="text-dark">
                    Lorem, ipsum dolor.
                  </h6>
                  <p className="text-dark">Lorem ipsum dolor sit amet.</p>
                </div>
              </div>
            </div>
          </div>
      </Container>
      <Container class1='special-wrapper py-5 home-wrapper-2'>
         <div className="row">
            <div className="col-12">
              <h3 className="section-heading">Special Products</h3>
            </div>
            <div className="row">
              <SpecialProduct />
              <SpecialProduct />
              <SpecialProduct />
            </div>
          </div>
      </Container>            
      <Container class1='marquee-wrapper py-5'>
        <div className="row">
          <div className="col-12">
            <div className="marquee-inner-wrapper card-wrapper">
              <Marquee className="d-flex">
                <div className="mx-4 w-20">
                  <img src="images/brand-01.png" alt="brand" className="img-fluid"/>
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-02.png" alt="brand" className="img-fluid"/>
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-03.png" alt="brand" className="img-fluid" />
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-04.png" alt="brand" className="img-fluid" />
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-05.png" alt="brand" className="img-fluid"/>
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-06.png" alt="brand" className="img-fluid" />
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-07.png" alt="brand" className="img-fluid" />
                </div>
                <div className="mx-4 w-20">
                  <img src="images/brand-08.png" alt="brand" className="img-fluid"/>
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </Container>            
      <Container class1='blog-wrapper py-5 home-wrapper-2'>
       <div className="row">
          <div className="col-12">
            <h3 className="section-heading">
              Our Latest News
            </h3>
          </div>
          <div className="col-3">
              <BlogCard />
          </div>
          <div className="col-3">
              <BlogCard />
          </div>
          <div className="col-3">
              <BlogCard />
          </div>
          <div className="col-3">
              <BlogCard />
          </div>
        </div>
      </Container>            
    </>
  )
}

export default Home